import React, { useEffect, useState } from "react";

import { Connect } from "./Connect";
import { Spinner } from "../components/Spinner";
import { GoogleDriveForm } from "./GoogleDriveForm";

import { getGapi } from "../../../../api/googleDrive";

enum Status {
  pending = "pending",
  success = "success",
  error = "error",
}

const components = {
  [Status.pending]: Spinner,
  [Status.success]: GoogleDriveForm,
  [Status.error]: Connect,
};

export const GoogleDrive: React.FC = () => {
  const [status, setStatus] = useState(Status.pending);

  /*
  * - add listener to Google API auth2
  * - check is sign in go Google API auth2
  * */
  useEffect(() => {
    const gapi = getGapi();
    const authInstance = gapi.auth2.getAuthInstance();
    // Listen for sign-in state changes.
    authInstance.isSignedIn.listen((isSignedIn: boolean) => {
      setStatus(Status[isSignedIn ? "success" : "error"]);
    });
    // Handle the initial sign-in state.
    setStatus(Status[authInstance.isSignedIn.get() ? "success" : "error"]);
  }, []);

  const Component = components[status];

  return <Component />;
};
